import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Big } from 'foundations-components/transitional/components/Big';
import { H3 } from 'foundations-components/transitional/components/H3';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import { Link } from 'foundations-components/transitional/components/Link';
import { TEMPLATE_TYPES } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import ChangeTemplateLoading from './ChangeTemplateLoading';
import TemplatePickerPanel from './TemplatePickerPanel';
import { useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.chooseTemplate.changeTemplatePage';
const ChangeTemplatePage = ({
  currentTemplate,
  onBackClick,
  onChooseTemplateClick,
  showLoadingOverlay
}) => {
  const [stagedTemplate, setStagedTemplate] = useState(currentTemplate);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "fullscreen",
    "data-test-id": "change-template-modal",
    children: [showLoadingOverlay && /*#__PURE__*/_jsx(ChangeTemplateLoading, {}), /*#__PURE__*/_jsx(Flex, {
      boxShadow: "100",
      position: "relative",
      minBlockSize: "72px",
      justifyContent: "center",
      inlineSize: "100%",
      paddingBlock: "400",
      paddingInline: "700",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        children: /*#__PURE__*/_jsxs(ToolBar, {
          children: [/*#__PURE__*/_jsx(ToolBarGroup, {
            use: "tabs",
            children: /*#__PURE__*/_jsx(BackButton, {
              children: /*#__PURE__*/_jsx(Link, {
                onClick: onBackClick,
                children: /*#__PURE__*/_jsx(Big, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `${I18N_PREFIX}.backButtonLabel`
                  })
                })
              })
            })
          }), /*#__PURE__*/_jsx(ToolBarGroup, {
            use: "tabs",
            justifyContent: "center",
            marginBlockEnd: "500",
            marginBlockStart: "200",
            children: /*#__PURE__*/_jsx(H3, {
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `${I18N_PREFIX}.header`
              })
            })
          }), /*#__PURE__*/_jsx(ToolBarGroup, {
            use: "tabs",
            children: /*#__PURE__*/_jsx(Button, {
              "data-test-id": "save-template-button",
              use: "primary",
              onClick: () => onChooseTemplateClick(stagedTemplate),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `${I18N_PREFIX}.saveButtonLabel`
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      padding: "1200",
      overflowY: "auto",
      children: /*#__PURE__*/_jsx(TemplatePickerPanel, {
        currentTemplate: stagedTemplate,
        onChooseTemplateClick: setStagedTemplate
      })
    })]
  });
};
ChangeTemplatePage.propTypes = {
  currentTemplate: PropTypes.oneOf(TEMPLATE_TYPES).isRequired,
  onBackClick: PropTypes.func.isRequired,
  onChooseTemplateClick: PropTypes.func.isRequired,
  showLoadingOverlay: PropTypes.bool.isRequired
};
export default ChangeTemplatePage;